import axios from "../axios";

const calculateProfit = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('dashboard/calculateProfit', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default calculateProfit; 
